import { EmptyState } from '@retailer-platform/shared-components/src/tds'
import { useDomainMessages } from '../../../../utils/intl'

export const NoContextsErrorState = () => {
  const messages = useDomainMessages({
    title: 'sharedEnterpriseToolsDomain.contextError.noContexts.title',
    description: 'sharedEnterpriseToolsDomain.contextError.noContexts.description',
  })

  return (
    <EmptyState icon="MagnifyingGlass" title={messages.title} description={messages.description} />
  )
}
